export default __webpack_public_path__ + "static/media/DolphinReader.babbb888.png";